import { render, staticRenderFns } from "./BannerMediaCard.vue?vue&type=template&id=66071212&"
import script from "./BannerMediaCard.vue?vue&type=script&lang=js&"
export * from "./BannerMediaCard.vue?vue&type=script&lang=js&"
import style0 from "./BannerMediaCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports